import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import WPCOMTestimonial from './wpcomtestimonial'

class WPCOMFailed extends React.Component {
	render() {
		const { migrate, history } = this.props
		const migrationError = migrate.getIn(['errors', 'message'])
		return <div className="wpcom">
			<div className="wpcom-migration-container">
				<main className="wpcom-migration-content">
					<h1>Your migration to WordPress.com has failed</h1>
					<p>
						The migration to WordPress.com failed with the following error &quot;{migrationError}&quot;
					</p>
					<p>
						&nbsp;You can try again or <a href="https://wordpress.com/support/contact/" className="dark-link" target="_blank" rel="noreferrer">contact us</a>
						&nbsp;if you would like us to do it for you. Our migration service is Free and you&apos;ll be up and running in no more than 2 business days.
					</p>
					{ history.length > 2 ? <div className="wpcom-migration-form">
						<div className="wpcom-migration-section">
							<button type="button" onClick={history.goBack}>Restart Migration</button>
						</div>
					</div> : null }
				</main>
				<WPCOMTestimonial migrate={migrate} />
			</div>
		</div>
	}         
}           

WPCOMFailed.propTypes = {
	migrate: ImmutablePropTypes.map,
	history: PropTypes.object
}

export default WPCOMFailed
